module.exports = "https://static.wmbcdn.com/uniweb/images/85dccc3b76a97be81146562a3ec074b7.svg";